import { catchError } from 'rxjs/operators'
import { of, merge } from 'rxjs'
import { combineEpics } from 'redux-observable'

//Basic app wide actions we want to share
export const APP_ERROR = 'APP_ERROR'

export const requestStatus = {
  pending: 'pending',
  complete: 'complete',
  rejected: 'rejected',
}
Object.freeze(requestStatus)

//Basic CreateReducer...
export const createReducer = (initialState, handlers) => {
  return (state = initialState, action) => {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action)
    } else {
      return state
    }
  }
}

export const combineEpicsFromImport = (epics) => {
  let epicValues = []
  Object.keys(epics).map((key) => {
    epicValues.push(epics[key])
  })

  return combineEpics(...epicValues)
}

//Our root catch error, normalizes how all root errors should look and behave.
//https://github.com/redux-observable/redux-observable/issues/591
export const rootCatchError = (actionType) => {
  return catchError((error, caught) => {
    return merge(
      of({
        type: actionType,
        payload: error,
        error: true,
      }),
      caught,
    )
  })
}

//This does sort the keys in the object at the first level, beyond that it is
//possible to have the order affect the hash., even though the data would be virutally
//the same
export const generateHashFromObject = (obj) => {
  return btoa(JSON.stringify(obj, Object.keys(obj).sort()))
}


//Simply converts some snake_case string to camelCase.
export const snakeToCamel = (str) => {
  return str.replace(/([-_][a-z])/g, (group) => {
    return group.toUpperCase().replace('-', '').replace('_', '')
  })
}

/**
 * Get the current date time as an ISO string
 * @returns {string}
 */
export const getCurrentISODate = () => {
  let now = new Date()
  return now.toISOString()
}
